import React from "react";
import styles from "./IntegrationCard.module.css";
import {DeleteIntegrationRequest, Integration, ToggleIntegrationRequest} from "../../../../../../api/generated";
import {getIntegrationMap} from "../../../../../../utils/enumValueTitleUtil";
import {EditButton} from "../../../../../elements/editButton/EditButton";
import {DeleteButton} from "../../../../../elements/deleteButton/DeleteButton";
import {useAppDispatch} from "../../../../../../app/hooks";
import {FormName, openForm} from "../../../../../elements/formProvider/formSlice";
import {openPopupModal, PopupModalName} from "../../../../../elements/popupModalProvider/popupModalSlice";
import {CustomSwitchField} from "../../../../../elements/customSwitchField/CustomSwitchField";
import {toggleIntegration} from "../slice/integrationsSlice";
import {showToastNotification} from "../../../../../elements/toastNotification/toastNotificationSlice";

interface IntegrationCardProps {
    publicBotId: string
    integration: Integration
    fullData: any
    configurationId: number
}

export const IntegrationCard: React.FC<IntegrationCardProps> = ({
                                                                    publicBotId,
                                                                    integration,
                                                                    fullData,
                                                                    configurationId
                                                                }) => {
    const dispatch = useAppDispatch();

    const getSrc = (): string => {
        switch (integration) {
            case Integration.Superchat:
                return "/superchatLogo.svg";
            default:
                throw new Error(`Unable to handle integration: ${integration} correctly`);
        }
    };

    const handleToggle = (enabled: boolean) => {
        dispatch(toggleIntegration({
            publicBotId: publicBotId,
            configurationId: configurationId,
            integration: integration
        } as ToggleIntegrationRequest));
        dispatch(showToastNotification({
            message: `Integration ${enabled ? "enabled" : "disabled"}`
        }))
    };

    const handleEditClick = () => {
        dispatch(openForm({
            name: FormName.UPDATE_INTEGRATION,
            formProps: {
                configurationData: {
                    publicBotId,
                    integration,
                    configurationId,
                    enabled: fullData.enabled,
                    superchatApiKey: fullData.apiKey,
                    superchatAimeUserEmail: fullData.aimeUserEmail,
                    superchatWebhookId: fullData.webhookId,
                    superchatHandoverUserEmailList: fullData.handoverUserEmailList ? fullData.handoverUserEmailList.join(";") : null
                }
            }
        }));
    };

    const handleDeleteClick = () => {
        dispatch(openPopupModal({
            name: PopupModalName.DELETE_INTEGRATION,
            popupModalProps: {
                deleteRequest: {
                    publicBotId,
                    configurationId,
                    integration
                } as DeleteIntegrationRequest
            }
        }))
    };

    return (
        <div className={styles.card}>
            <div className={styles.switchWrapper}>
                <CustomSwitchField
                    textOnTrue={""}
                    textOnFalse={""}
                    value={fullData?.enabled}
                    toggleValue={handleToggle}
                />
            </div>
            <div className={styles.main}>
                <img className={styles.logo} src={getSrc()} alt="logo"/>
                <span className={styles.name}>{getIntegrationMap(integration)}</span>
                <span className={styles.description}>Connect customer communications seamlessly</span>
                <span className={`${styles.status} ${fullData.enabled ? styles.active : styles.inactive}`}>
                    {fullData.enabled ? "Active" : "Inactive"}
                </span>
            </div>
            <div className={styles.actions}>
                <EditButton handleClick={handleEditClick}/>
                <DeleteButton handleClick={handleDeleteClick}/>
            </div>
        </div>
    );
}
